import { useEffect, useRef } from 'react'
import { useAtomValue } from 'jotai'
import { useNavigate, useLocation } from 'react-router'
import { session } from '../store'

export function useRequireAuthentication() {
  const authState = useAtomValue(session.sessionStatusAtom)
  const navigate = useNavigate()
  const location = useLocation()
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (authState === 'unauthenticated' && !hasRedirected.current) {
      hasRedirected.current = true
      navigate('/login', { state: { from: location.pathname }, replace: true })
    }
  }, [authState, navigate, location.pathname])
}
